import { render, staticRenderFns } from "./BaseInputBox.vue?vue&type=template&id=703a003e&functional=true&"
import script from "./BaseInputBox.vue?vue&type=script&lang=ts&"
export * from "./BaseInputBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports